import en from './en';
import de from './de';

const concatenate = (value: Record<string, any>, prev: string = ''): any => {
  return Object.keys(value).reduce((carry: any, key: string) => {
    const prefix = prev.length > 1 ? `${prev}.${key}` : key;

    if (typeof value[key] !== 'string') {
      return {
        ...carry,
        ...concatenate(value[key], prefix),
      };
    } else {
      return {
        ...carry,
        [prefix]: value[key],
      };
    }
  }, {});
};

export const supportedLocales = ['en', 'de'];

const translations = {
  en: concatenate(en),
  de: concatenate(de),
};

const messages = () => {
  let locale = navigator.language.split(/[-_]/)[0];

  switch (locale) {
    case 'en':
      return { locale, messages: translations['en'] };
    case 'de':
      return { locale, messages: translations['de'] };
    default:
      return { locale, messages: translations['en'] };
  }
};

export default messages();
